import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, NavLink } from "react-router-dom";
import Logo from "../../assets/images/Logo/Logo.png";

const TopNavBanner = ({ className }) => {
  let location = window.location;
  let pathname = location.pathname;

  const [expanded, setExpanded] = useState(false);

  const handleNavToggle = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        // Scroll the element into view with a smooth scroll behavior
        element.scrollIntoView({
          behavior: "smooth",
          block: "start", // Align the element to the top of the viewport
        });
  
        // Adjust the scroll position by the height of the sticky navbar (80px)
        window.scrollBy(0, -80); // Adjust the scroll by the navbar's height (80px)
      }
    }
  }, [location]);
  

  const activeLink = (route) => {
    return pathname === route || location.hash === route ? true : false;
  };

  return (
    <div className={`top-nav-bar ${className}`}>
      <Navbar expand="lg" variant="dark">
        <Container>
          <Navbar.Brand href="/">
            <img src={Logo} alt="Socius" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={handleNavToggle}
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav
              className="ms-auto d-flex align-items-center gap-2 fw-700"
              defaultActiveKey="/"
              onClick={handleNavToggle}
            >
              <Nav.Item className={"p-3"}>
                {/* <Link
                  to={'/'}
                  onClick={handleNavToggle}
                  className={activeLink("/") ? "active" : ""}
                >
                  Home
                </Link> */}
              </Nav.Item>
              <Nav.Item className={"p-3 pb-2"} style={{ borderBottom: activeLink("#feature") ? "2px solid #FF6F61" : ""}}>
                <Link
                  to={`${location.origin}#feature`}
                  onClick={handleNavToggle}
                  className={activeLink("#feature") ? "active" : ""}
                >
                  Features
                </Link>
              </Nav.Item>
              <Nav.Item className={"p-3 pb-2"} style={{ borderBottom: activeLink("/about-us") ? "2px solid #FF6F61" : ""}}>
                <Link
                  to={"/about-us"}
                  onClick={handleNavToggle}
                  className={activeLink("/about-us") ? "active" : ""}
                >
                  About us
                </Link>
              </Nav.Item>
              <Nav.Item className={"p-3 pb-2"} style={{ borderBottom: activeLink("#reviews") ? "2px solid #FF6F61" : ""}}>
                <Link
                  to={`${location.origin}#reviews`}
                  onClick={handleNavToggle}
                  className={activeLink("#reviews") ? "active" : ""}
                >
                  Reviews
                </Link>
              </Nav.Item>
              <Nav.Item className={"p-3 pb-2"} style={{ borderBottom: activeLink("/contact-us") ? "2px solid #FF6F61" : ""}}>
                <Link
                  to={"/contact-us"}
                  onClick={handleNavToggle}
                  className={activeLink("/contact-us") ? "active" : ""}
                >
                  Contact Us
                </Link>
              </Nav.Item>
              <Link
                to={`${location.origin}#about-us`}
                className="pb-1"
                onClick={handleNavToggle}
              >
                <Button className="btn-theme-default btn-contact-us">
                  Download App
                </Button>
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default TopNavBanner;
